import { render, staticRenderFns } from "./SettingsAccountRemove.vue?vue&type=template&id=f5c6aa3a&scoped=true"
import script from "./SettingsAccountRemove.vue?vue&type=script&lang=js"
export * from "./SettingsAccountRemove.vue?vue&type=script&lang=js"
import style0 from "./SettingsAccountRemove.vue?vue&type=style&index=0&id=f5c6aa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c6aa3a",
  null
  
)

export default component.exports